// @ts-expect-error Untyped module
import ExtensionInstallHelpers from 'ExtensionInstallHelpers/SidekickExtensionInstallHelpers';
import { updateFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { getShowProductSetupUIBranch } from '../../store/flow/selectors';
import { getIntentLink } from '../../intents/intentSelectors';
import { getIsMobile } from '../../utils/deviceUtils';
export const ProductSetupUIBranch = {
  name: 'ProductSetupUIBranch',
  stateCheck: state => {
    const hasSalesExtension = ExtensionInstallHelpers.hasExtension();
    return !hasSalesExtension && getShowProductSetupUIBranch(getIntentLink(state));
  },
  rebuildFlow: (flow, state, dispatch) => {
    let postAccountCreationSteps = getFlowSteps().postAccountCreation;
    let postExistingAccountSelectionSteps = getFlowSteps().postExistingAccountSelection;
    let flowSteps = flow;

    if (!getIsMobile()) {
      flowSteps = [...flowSteps, Step.InstallSalesExtension];
      postAccountCreationSteps = [...postAccountCreationSteps, Step.InstallSalesExtension];
      postExistingAccountSelectionSteps = [...postExistingAccountSelectionSteps, Step.InstallSalesExtension];
    }

    dispatch(updateFlow(getFlowSteps().preVerification, getFlowSteps().postVerification, postAccountCreationSteps, postExistingAccountSelectionSteps));
    return flowSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};